/** @jsx jsx */
import React from 'react'
import { jsx } from 'theme-ui'
import { css } from '@emotion/react'
import { get } from 'lodash'

import CTA from './cta'

import { Cont, FlexCols, FlexCol, VStack } from '../../styles/els'

const CTAs = (props) => {
  const { ctas, ...otherProps } = props

  return ctas && ctas.length > 0 ? (
    <section>
      <Cont>
        <VStack space={[4, 7]}>
          {ctas.map((_cta, _i) => {
            const __cta = get(_cta, 'cta.0')
            return __cta ? <CTA key={_i} {...__cta} /> : null
          })}
        </VStack>
      </Cont>
    </section>
  ) : null
}

export default CTAs
